import { useEffect, useState } from 'react'
import { Link, useLocation, useRouteLoaderData } from 'react-router'
import type { RootData } from '@/root'
import linksConfig from '@/site/lib/linksConfig'
import FacetMenu from './FacetMenu'
import SearchInput from './SearchInput'

/** Top bar: the control panel's banner (when set) and links to the Missouri Star shop. */
function TopBar() {
  const banner = useRouteLoaderData<RootData>('root')?.site.banner

  return (
    <div className="bg-qt-primary text-[13px] font-semibold text-white">
      <div className="qt-container flex min-h-10 items-center justify-between gap-6 py-2">
        {banner ? (
          <p>
            {banner.text}
            {banner.link_url && (
              <>
                {' '}
                {banner.link_url.startsWith('/') ? (
                  <Link to={banner.link_url} className="underline underline-offset-2">
                    {banner.link_label}
                  </Link>
                ) : (
                  <a href={banner.link_url} className="underline underline-offset-2">
                    {banner.link_label}
                  </a>
                )}
              </>
            )}
          </p>
        ) : (
          <p>Free quilting video tutorials from Missouri Star</p>
        )}
        <nav aria-label="Missouri Star Quilt Co." className="hidden shrink-0 gap-6 md:flex">
          {linksConfig.quickLinks.map((l) => (
            <a key={l.title} href={l.location} target="_blank" rel="noreferrer" className="hover:underline">
              {l.title}
            </a>
          ))}
        </nav>
      </div>
    </div>
  )
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { key } = useLocation()

  // Close the phone menu after navigating.
  useEffect(() => setMenuOpen(false), [key])

  return (
    <>
      <TopBar />
      <header className="qt-container flex flex-wrap items-center gap-x-10 gap-y-3 py-4 md:py-5">
        <Link to="/" className="shrink-0">
          <img src="/img/logo.svg" alt="Quilting Tutorials" width="187" height="46" className="h-9 w-auto md:h-11" />
        </Link>
        <SearchInput className="order-3 w-full md:order-none md:w-auto md:flex-1" />
        <button
          type="button"
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="site-menu"
          onClick={() => setMenuOpen((o) => !o)}
          className="ml-auto flex size-11 items-center justify-center rounded-xl bg-qt-soft text-qt-primary md:hidden"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            {menuOpen ? <path d="M6 6l12 12M18 6 6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </header>
      <FacetMenu mobileOpen={menuOpen} />
    </>
  )
}
